import helpCenter from '@sv-support-sdk/api/src/modules/helpCenter';
import tickets from '@sv-support-sdk/api/src/modules/tickets';
import chats from '@sv-support-sdk/api/src/modules/chats';
import faq from '@sv-support-sdk/api/src/modules/faq';
import releaseNotes from '@sv-support-sdk/api/src/modules/releaseNotes';
import search from '@sv-support-sdk/api/src/modules/search';

import user from './modules/user';
import customerEffort from './modules/customerEffort';
import instance from './instance';

export default {
  helpCenter: helpCenter(instance),
  tickets: tickets(instance),
  chats: chats(instance),
  faq: faq(instance),
  releaseNotes: releaseNotes(instance),
  search: search(instance),
  user,
  customerEffort,
};
